export const STICKY_NOTE_DEFAULT_COLOR = '#EBDEFF';
export const STICKY_NOTE_DEFAULT_WIDTH = 240;
export const STICKY_NOTE_DEFAULT_HEIGHT = 240;
export const STICKY_NOTE_MIN_HEIGHT = 240;
export const STICKY_NOTE_EXPANDED_WIDTH = 320; // + 75% of the default width
